// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Heading from '../../../../generic-components/Heading';
import { vendorPickerContentMap } from '../../consts';
import { ReactComponent as RightArrowIcon } from '../../../../assets/icons/svg/shared/ic-shared-right-arrow.svg';
import { ReactComponent as AddVendorIcon } from '../../../../assets/icons/svg/shared/ic-shared-add-account.svg';

interface IAddNewVendorProps {
    onAddNewVendor: () => void;
}

export const AddNewVendor = (props: IAddNewVendorProps) => {
  const { onAddNewVendor } = props;
  const { t } = useTranslation();
  const { moveType } = useParams();
  return (
    <button id='addNewPayee' onClick={onAddNewVendor} type='button' className='w-fit mx-auto'>
      <div
        className='hover:bg-bw02 active:bg-bw03 transition-all ease-in pl-[10px] pr-[22px] py-[10px] rounded-[8px] mb-[16px] w-[395px] flex items-center'
      >
        <AddVendorIcon className='w-[40px]' />
        <Heading
          title={t(vendorPickerContentMap[moveType as keyof typeof vendorPickerContentMap].add_list_item)}
          className='text-bw08 ml-[10px] text-[16px] font-metricRMedium'
        />
        <RightArrowIcon className='ml-auto' />
      </div>
    </button>
  );
};
